import React from 'react';
import ChevronUp from 'mdi-react/ChevronUpIcon';
import ChevronDown from 'mdi-react/ChevronDownIcon';

import * as S from './styles';

type OwnProps = {
  expanded: boolean;
  onClick: () => void;
  title?: string;
};

const ExpandButton = React.memo(({ expanded, onClick, title }: OwnProps) => (
  <S.ExpandWrapper type="button" aria-label={title} onClick={onClick}>
    <S.ExpandButton data-test="ExpandButton">
      {expanded ? <ChevronUp /> : <ChevronDown />}
    </S.ExpandButton>
  </S.ExpandWrapper>
));

export default ExpandButton;
